
import Vue from "vue";
import { LOYALTY } from "@/store/loyalty";
import store from "@/store";
import { IRootState } from "@/store/types";
import { required, maxLength } from "vuelidate/lib/validators";
import { mapGetters, mapState } from "vuex";
import { LoyaltySchemeType, OfferLevelType } from "@/store/loyalty/types";

export default Vue.extend({
  props: {
    pagination: Object
  },
  data() {
    return {
      isLoading: false,
      LoyaltySchemeType: LoyaltySchemeType,
      offerLevelType: OfferLevelType
    };
  },
  computed: {
    dialogType() {
      return this.activeCustomerCard && this.activeCustomerCard.dialogType;
    },
    customerName() {
      return (
        this.$store.state.loyalty.customer &&
        this.$store.state.loyalty.customer.customerName
      );
    },
    cardNumber: {
      get() {
        return this.activeCustomerCard && this.activeCustomerCard.cardNumber;
      },
      set(value: any) {
        this.$store.dispatch(
          LOYALTY.NS(LOYALTY.ACTIONS.SET_ACTIVE_CUSTOMER_CARD),
          { ...this.activeCustomerCard, cardNumber: value }
        );
      }
    },
    costCentreCode: {
      get() {
        return (
          this.activeCustomerCard && this.activeCustomerCard.costCentreCode
        );
      },
      set(value: any) {
        this.$store.dispatch(
          LOYALTY.NS(LOYALTY.ACTIONS.SET_ACTIVE_CUSTOMER_CARD),
          { ...this.activeCustomerCard, costCentreCode: value }
        );
      }
    },
    showDialog() {
      return !!this.activeCustomerCard;
    },
    ...mapState({
      activeCustomerCard: (state: IRootState) =>
        state.loyalty.activeCustomerCard
    })
  },
  methods: {
    onInput(value: any) {
      // false value is emitted when x button is clicked
      if (value === false) {
        this.$store.dispatch(
          LOYALTY.NS(LOYALTY.ACTIONS.SET_ACTIVE_CUSTOMER_CARD),
          undefined
        );
      }
    }
  }
});
